"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SerializationOptionsMock = void 0;
exports.SerializationOptionsMock = {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    SerializeOptions: (args) => undefined
};
